const translations = {
    title: 'Company Registration',
    description: '',
    canonical: 'string',
    image: '',
    robots: '',
};

export default translations;